// GK 2023-10-21 - Auth Component deals with user authentication, of course

import { useState, useEffect } from "react";
import { Button, Form, Input, message, Alert, Col, Row, Typography } from "antd";
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/auth-context';
import './styles/AdminLogin.css';

// This is the login page specifically for users who are Admins
// E.g. punkypay.com/admin
const AdminLogin = ({ title }) => {
  const { Text, Link: AntLink } = Typography;
  const auth = useAuth();
  const navigate = useNavigate();

  const [messageApi, contextHolder] = message.useMessage();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [authError, setAuthError] = useState('');
   // unverifiedUser is a user that has signed up but hasn't verified his email
  const [unverifiedUser, setUnverifiedUser] = useState(null);
  const [verificationEmailSent, setVerificationEmailSent] = useState(false);
  const [authenticating, setAuthenticating] = useState(false);

  // useEffect(() => {
  //   console.log('admin auth --->', auth);
  //   if (auth.currentUser) {
  //     console.log('current user -->', auth.currentUser)
  //     if (auth.currentUser.role?.toLowerCase() === 'admin') {
  //       navigate('/admin/dashboard');
  //     } else {
  //       setAuthError('Only an admin user can login');
  //       auth.signOut();
  //     }
  //   }
  // }, [auth.currentUser]);

  // GK 2023-10-21 - Handles logins and errors to be shown to the user
  const handleLogin = async () => {
    try {
      setAuthenticating(true);
      setAuthError('');
      const resp = await auth.signIn(email.toLowerCase().trim(), password);
      
      if(resp.user?.emailVerified === false) {
        setUnverifiedUser(resp.user);
      }
      setAuthenticating(false);
    } catch (error) {
      setAuthenticating(false);
      if (error.code === "auth/wrong-password") {
        messageApi.open({
          type: "error",
          content: "Password is invalid. Please try again!",
        });
        setAuthError('Password is invalid. Please try again!');
        return;
      }
      if (error.code === "auth/user-not-found") {
        messageApi.open({
          type: "error",
          content: "Email is invalid.",
        });
        setAuthError('Email is invalid. Please try again!');
        return;
      }

        messageApi.open({
          type: "error",
          content: "Unable to login. Please try again",
        });
        setAuthError('Unable to login. Please try again!');
    }
  }

  const onFinish = () => {
    handleLogin();
  }

  // GK 2023-10-21 - runs if there is a failure after form submit
  // AntDesign supplies the errorInfo automatically
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onResendVerificationEmail = async () => {
    try {
      if(unverifiedUser?.emailVerified === false) {
        await auth.sendUserVerificationEmail(unverifiedUser);
        setAuthError('');
        setVerificationEmailSent(true);
      }
    } catch (error) {
      setAuthError('Something went wrong while resending the verification email. Please try again!');
    }
  }

  const showResendEmailMessage = () => {
    return <Text>
      This account needs email verification. Please check your email or <a onClick={onResendVerificationEmail}>resend verification email</a>
      </Text>
  }
  
  // GK 2023-10-21 - below defines how the form actually looks/behaves
  return (
    <div style={{paddingTop: 20}}>
      <Row>
        <Col xs={{span: 24}} md={{span: 16, offset: 4}}>
            {
              (verificationEmailSent) && 
                (<Alert 
                    message={`Verification email sent. Don't forget to check your Spam!`} 
                    type="success"
                    className="text-center" 
                />)
            }
            {
                authError && 
                (<Alert 
                    message={authError} 
                    type="error"
                    className="text-center" 
                />)
            }
            {
                !verificationEmailSent && auth.userIsVerified === false && 
                (
                    <Alert 
                        message={showResendEmailMessage()} 
                        type="warning"
                        className="text-center" 
                    />
                )
            }
        </Col>
      </Row>
      <h2 className="auth-header">Admin Login</h2>
      <Form
        name="basic"
        //layout="vertical"
        labelCol={{
          xs: {span: 24},
          md: {span: 8}
        }}
        wrapperCol={{
          xs: {span: 24},
          md: {span: 8},
        }}
        initialValues={{
          termsAndConditions: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              message: "Please enter your email!",
            },
            {
              type: 'email',
              message: 'The input is not a valid email!',
            },
          ]}
          className="form-item"
        >
          <Input 
            onChange={(e) => setEmail(e.target.value)} 
            placeholder="Enter your email" 
          />
        </Form.Item>

        <Form.Item
          className="form-item"
          label="Password"
          name="password"
          rules={[
            {
              required: true,
              message: "Please enter your password!",
            },
          ]}
        >
          <Input.Password 
            onChange={(e) => setPassword(e.target.value)} 
            placeholder="Enter your password" 
          />
        </Form.Item>

        <Form.Item
          className="form-item form-item__submit"
          wrapperCol={{
            md: {
              offset: 8,
              span: 16,
            },
            xs: {
              span: 24,
            },
          }}
        >
          <Button type="primary" htmlType="submit" disabled={authenticating}>
            Login
          </Button>
        </Form.Item>
      </Form>
      <Row className="auth-links-section">
        <Col 
          xs={{span: 24}}
          md={{span: 16, offset: 8}}
        >
            <div>
                <Link to="/password-reset" className="text-link">Forget your password? Click here</Link>
            </div>
        </Col>
      </Row>
    </div>
  );
};

export default AdminLogin;
